<template>
  <div>
    <van-nav-bar title="千里马-箱盟 加油核销" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div style="margin: 20px;" :class="button1">
      <van-button round block type="primary" @click="scan()">扫码核销</van-button>
    </div>
    <van-form @submit="onSubmit" :class="form1">
      <van-field v-model="orderNo" label="订单号" placeholder="订单号" :readonly=true :rules="[{ required: true, message: '请填写订单号' }]" class="custom-style"/>
      <van-field v-model="plateNum" name="车牌号" label="车牌号" placeholder="车牌号" :readonly=true :rules="[{ required: true, message: '请填写车牌号' }]"
                 class="custom-style"/>
      <van-field v-model="driverPhone" name="手机号" label="手机号" placeholder="手机号" :readonly=true :rules="[{ required: true, message: '请填写手机号' }]"
                 class="custom-style"/>
      <van-field v-model="applyVolume" name="最大可加油量" label="最大可加油量" placeholder="最大可加油量" :readonly="true" class="custom-style"/>
      <van-field v-model="oilQuality" name="油品" label="油品" placeholder="油品" :readonly=true class="custom-style"/>
      <van-field v-model="oilNum" label="实际加油量" placeholder="请输入实际加油量" :rules="[{ required: true, message: '请填写实际加油量' }]" class="custom-style"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">再点提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button} from 'vant';
import wx from "weixin-js-sdk";
import {MessageBox} from "mint-ui";
import common from "../../common";

Vue.use(Button);

export default {
  data() {
    return {
      form1: "form-hide",
      button1: "form-display",
      orderNo: "",
      plateNum: "",
      driverPhone: "",
      applyVolume: "",
      oilQuality: "",
      oilNum: "",
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/"});
    },
    scan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          MessageBox(res.resultStr);
          this.getOrderDetail();
        }
      });
    },
    //获取数据
    getData() {
      let querystring = require("querystring");
      this.$api.post("/wx/jsConfig",
          querystring.stringify({
            url: location.href.split("#")[0]
          })
      ).then(data => {
        wx.config({
          debug: false,
          appId: data.data.data.appId,
          timestamp: data.data.data.timestamp,
          nonceStr: data.data.data.nonceStr,
          signature: data.data.data.signature,
          jsApiList: ["scanQRCode"]
        });
      }).catch(err => {
        common.toast(err);
      });
    },
    getOrderDetail(orderNo) {
      let querystring = require("querystring");
      this.$api.post("/wx/putbox/orderDetail",
          querystring.stringify({
            orderNo: this.orderNo,
          })
      ).then(data => {
        console.log(data);
        if (data.data.code == 0) {
          this.form1 = "form-display";
          this.button1 = "form-hide";
          this.plateNum = data.data.data.plateNum;
          this.driverPhone = data.data.data.driverPhone;
          this.orderNo = data.data.data.orderNo;
          this.applyVolume = data.data.data.applyVolume;
          this.oilQuality = data.data.data.oilQuality;
        }
      }).catch(err => {
        common.toast(err);
      });
    },
    onSubmit() {

    },
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>
.custom-style {
  font-size: 0.45rem;
}

.form-hide {
  display: none;
}

.form-display {
}
</style>


// WEBPACK FOOTER //
// src/components/putbox/order.vue